<template>
  <div
    v-if="eventId"
    id="admin"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <h1>Admin Interface</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <AdminList
          :list="admins"
        />
      </v-col>
      <v-col cols="4">
        <AdminAdd />
      </v-col>
      <v-col cols="5">
        <AdminEventDetails />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ProgressButton
          :current-user="currentUser"
          :event-id="eventId"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="canModifyEvent">
        <AddPrizes
          :client="adminClient"
        />
      </v-col>
      <v-col>
        <GiveawayStats
          v-if="eventState !== 'Completed'"
          :current-user="currentUser"
          :event-id="eventId"
        />
        <PrizeSlackers
          v-if="canSetPrizePreference"
        />
      </v-col>
      <v-col
        v-if="needToSetPresentationTime"
      >
        <AdminCustomizeScheduleOptions />
      </v-col>
      <v-col
        v-if="needToSetPresentationTime"
      >
        <AdminPresentationTime />
      </v-col>
      <v-col v-if="eventState === 'Judging'">
        <VotingProgress
          :team-results="teamResults"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="shouldGetVotingResults">
        <VotingResults
          :results="teamResults"
        />
      </v-col>
      <v-col v-if="judgingIsCompleted">
        <PrizeWinners
          :winners="prizeWinners"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable import/no-cycle */
import AdminAdd from '@/components/AdminAdd.vue';
import AdminClient from '@/api/AdminClient';
import AdminEventDetails from '@/components/AdminEventDetails.vue';
import AddPrizes from '@/components/AddPrizes.vue';
import AdminPresentationTime from '@/components/AdminPresentationTime.vue';
import AdminCustomizeScheduleOptions from '@/components/AdminCustomizeScheduleOptions.vue';
import AdminList from '@/components/AdminList.vue';
import GiveawayStats from '@/components/GiveawayStats.vue';
import PrizeSlackers from '@/components/PrizeSlackers.vue';
import ProgressButton from '@/components/ProgressButton.vue';
import VotingProgress from '@/components/VotingProgress.vue';
import VotingResults from '@/components/VotingResults.vue';
import PrizeWinners from '@/components/PrizeWinners.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Admin',
  components: {
    AdminAdd,
    AddPrizes,
    AdminEventDetails,
    AdminList,
    AdminPresentationTime,
    AdminCustomizeScheduleOptions,
    GiveawayStats,
    PrizeSlackers,
    ProgressButton,
    VotingProgress,
    VotingResults,
    PrizeWinners,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      eventId: null,
      adminClient: null,
      teamResults: [],
      prizeWinners: [],
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
      eventState: 'eventState',
      admins: 'admins',
      presentationTimeSeconds: 'presentationTimeSeconds',
    }),
    canModifyEvent() {
      return this.eventState === 'Setup' || this.eventState === 'Registration';
    },
    canSetPrizePreference() {
      return this.eventState === 'Hacking' || this.eventState === 'Judging';
    },
    shouldGetPeopleMissingPrizes() {
      return (this.eventState === 'Hacking' || this.eventState === 'Judging');
    },
    judgingIsCompleted() {
      return this.eventState === 'PrizeSelection' || this.eventState === 'Completed';
    },
    shouldGetVotingResults() {
      return this.eventState === 'Judging' || this.eventState === 'PrizeSelection' || this.eventState === 'Completed';
    },
    needToSetPresentationTime() {
      return this.eventState === 'Hacking'
      && (this.presentationTimeSeconds === null
      || this.presentationTimeSeconds === undefined);
    },
  },
  mounted() {
    this.eventId = this.$store.state.hackathonID || null;
    if (!this.eventId === null) {
      // TODO the events should be retrieved in App.vue, not Main.vue
      this.$router.push('/');
    }
    this.adminClient = new AdminClient(this.currentJwtToken);
    this.getVotingResults();
  },
  methods: {
    async getVotingResults() {
      const results = await this.adminClient.getResults(this.eventId);
      if (this.eventState === 'Judging') {
        this.teamResults = results.teams;
      } else {
        this.teamResults = results.teams
          .filter((t) => t.standing > 0)
          .map((t) => {
            const result = {
              ...t,
            };
            result.prizes = t.members.every((tm) => tm.prize !== undefined) ? 'yes' : '';
            const sumTotal = t.finalScore.awesomeness
              + t.finalScore.innovation
              + t.finalScore.completeness
              + t.finalScore.utility
              + t.finalScore.difficulty;
            result.finalScore.total = sumTotal / 5;
            return result;
          });
        /* eslint-disable-next-line no-restricted-syntax */
        for (const team of results.teams) {
          this.prizeWinners.push(...team.members.filter((tm) => tm.prize));
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#admin {
  background: white;
  padding: 1em;
}
</style>
